import React from "react";
import { APP_TO_BUILD } from "../../appsConfig";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import robotImg from "../../otherAppAssets/ibew_aptitude/specificPractice/robot.png";
import { getUpgradeBannerCopy } from "@/i18n/studyBannerCopy";

interface UpgradeBannerProps {
  className?: string;
  header?: string;
  description?: string;
}

/**
 * UpgradeBanner Component
 *
 * A promotional banner that encourages users to upgrade their account
 * to access exam preparation features.
 */
const UpgradeBanner: React.FC<UpgradeBannerProps> = ({
  className = "",
  header,
  description,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isIbew = APP_TO_BUILD === "ibew_aptitude";
  const banner = getUpgradeBannerCopy(t, APP_TO_BUILD);

  return (
    <button
      onClick={() => navigate("/paywall")}
      className={`relative flex items-center gap-4 overflow-hidden rounded-xl border border-[#DADADA] bg-[var(--dp-brand-button)] p-4 text-left ${className}`}
      aria-label={t("upgrade.promotion_aria")}
    >
      {isIbew ? (
        <>
          {/* Robot Image for IBEW */}
          <div className="relative z-10">
            <img
              src={robotImg}
              alt={t("upgrade.ai_robot_alt")}
              className="w-[60px] h-[60px] object-contain"
            />
          </div>
        </>
      ) : (
        <>
          <div className="w-[161px] h-[125%] absolute -left-[40px] -top-[22px] rounded-full bg-[#73BB6D] z-0"></div>
          {/* Dakota Logo Section */}
          <div className="flex flex-col items-start justify-start relative z-10">
            <div className="text-white text-2xl font-lalezar text-center">
              DAKOTA
            </div>
            <div className="w-[60px] h-[15px] overflow-hidden">
              <img
                src="https://storage.googleapis.com/tempo-public-images/figma-exports%2Fgithub%7C168204332-1748589826100-node-238%3A27055-1748589824949.png"
                alt={t("upgrade.all_access_badge_alt")}
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </>
      )}
      {/* Content Section */}
      <div className="flex-1 pl-[16px]">
        <h3 className="text-white text-base font-bold font-inter">
          {header ?? banner.header}
        </h3>
        <p className="text-white/70 text-sm font-medium leading-[14px] font-inter w-[200px] mt-[4px]">
          {description ?? banner.description}
        </p>
      </div>
    </button>
  );
};

export default UpgradeBanner;
